import { useContext } from 'react'
import { useNotificationContext } from 'units/notifications/NotificationContext'
import PlatformContext from 'context/platform/PlatformContext'
import useScanner from './useScanner'

function Scanner({
    scannerTrigger,
    setScannerTrigger,
    setFieldValue,
    updateItems,
    setImages,
    imagesSpec,
    onScanned,
}) {

    const { addNotification } = useNotificationContext()
    const platform = useContext(PlatformContext)

    const scannedImagesLocation = platform.scannedImagesLocation

    useScanner({
        scannerTrigger,
        onSuccess: ({
            items,
            fields,
            images,
            imagesObject,
            missingImages,
        }) => {
            // A fresh scan replaces the images, so stale validations no longer
            // apply; they resurface on the next save if the problem persists.
            onScanned?.()

            updateItems(items)
            // if (fields) {
            //   Object.entries(fields).forEach(([key, value]) => {
            //     setFieldValue(key, value)
            //   })
            // }

            let resolvedImagesObject
            if (imagesObject) {
                resolvedImagesObject = imagesObject
            }
            else {
                resolvedImagesObject = imagesSpec.reduce((result, imageSpec) => {
                    const fileName = images[`${imageSpec.key}Name`]
                    const fullPath = `${scannedImagesLocation}${fileName}`
                    return {
                        ...result,
                        [imageSpec.fieldName]: {
                            imageType: imageSpec.imageType,
                            name: imageSpec.key,
                            url: fullPath,
                        },
                    }
                }, {})
            }
            Object.entries(resolvedImagesObject).forEach(([key, value]) => {
                setFieldValue(`images.${key}`, value)
            })
            setImages(resolvedImagesObject)
        },
        onError: (error) => {
            addNotification({
                type: 'error',
                content: error?.message,
            })
        },
        onDone: () => {
            setScannerTrigger(false)
        },
    })

    return null
}

export default Scanner
